import React from 'react';
import { Autocomplete } from '@costar/theme-ui-autocomplete';
import { createCurrentLayoutIdSelector } from './selectors/current-layout-id-selector.esm.js';
import { createLayoutListOptionsSelector } from './selectors/layout-list-options-selector.esm.js';
import { createChangeLayoutCallbackSelector } from './selectors/change-layout-callback-selector.esm.js';

var isOptionEqualToValue = function isOptionEqualToValue(option, value) {
  return option.id === value.id;
};
var groupBy = function groupBy(option) {
  return option.group;
};
var getOptionLabel = function getOptionLabel(option) {
  return option.label;
};
function createSelectListHeader() {
  var currentLayoutIdSelector = createCurrentLayoutIdSelector();
  var layoutListOptionsSelector = createLayoutListOptionsSelector();
  var changeLayoutCallbackSelector = createChangeLayoutCallbackSelector();
  function SelectListHeader(props) {
    return /*#__PURE__*/React.createElement(Autocomplete, {
      mode: "select",
      "automation-id": "selected-layouts",
      fontSize: "sm",
      width: "100%",
      options: layoutListOptionsSelector(props),
      value: currentLayoutIdSelector(props),
      groupBy: groupBy,
      isOptionEqualToValue: isOptionEqualToValue,
      getOptionLabel: getOptionLabel,
      onChange: changeLayoutCallbackSelector(props),
      disableClearable: true
    });
  }
  SelectListHeader.displayName = 'SelectListHeader';
  return SelectListHeader;
}

export { createSelectListHeader };
//# sourceMappingURL=select-list-header.esm.js.map
